import { OnDestroy, ViewEncapsulation, ViewChild, HostListener, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, animate, transition, style, keyframes } from '@angular/animations';
import { GlobalInfo } from '../././shared/shared.model';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../././shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../././shared/base.component';
import { LoaderService } from '.././shared/loader.service';
import { DatePipe } from '@angular/common';
import { ReceivedSmsService } from './received-sms.service'
import { SmsLogReceived } from '../work-order/work-order-models';
@Component({
    selector: 'received-sms',
    templateUrl: 'received-sms.component.html',
    animations: [
        trigger('isVisibleChanged', [
            transition('void => *', [
                animate(900, keyframes([
                    style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
                    style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ])
        ])
    ]
})
export class ReceivedSMSComponent extends BaseComponent implements OnInit {
    @Output() done = new EventEmitter();
    @Output() open = new EventEmitter();
    smslogReceived: SmsLogReceived[] = [];
    smslogReceivedselected: SmsLogReceived;
    IsNotification: boolean = false;
    public smsloghedr: string;
    public cencelpry: string;
    public fromNumber: string;
    public userName: string;
    public mesg: string;
    public receDatetime: string;
    public more: string;
    isVisible: Boolean = false;
    public rowsperOptions: any;
    public getRows: number;
    constructor(protected sharedService: SharedService, protected translate: TranslateService,
        protected receivedsmsService: ReceivedSmsService, private datePipe: DatePipe, private route: ActivatedRoute,
        private router: Router, private loaderservice: LoaderService) {
        super(sharedService, translate);
        this.rowsperOptions = this.sharedService.getRowsPerOptions();
        this.getRows = this.sharedService.getRows();
    }
    ngOnInit() {
        this.IsNotification = false;

        this.smsloghedr = this.translate.instant('SMSLog');
        this.cencelpry = this.translate.instant('CANCEL');
        this.fromNumber = this.translate.instant('FROMNUMBER');
        this.userName = this.translate.instant('USERNAME');
        this.mesg = this.translate.instant('MSGES');
        this.receDatetime = this.translate.instant('RECEIVEDDATETIME');
        this.more = this.translate.instant('MORE');

        this.receivedsmsService.getSmsReceivedLog(this.globalInfo().CompanyId, this.globalInfo().MaxRoleGroup, this.globalInfo().VendorId, this.globalInfo().LoginId, this.globalInfo().TimeZoneId).subscribe(resp => {

            this.smslogReceived = resp;

            this.smslogReceived.map(m => {

                m.RecvdDate = this.datePipe.transform(m.RecvdDate, 'short');
                return m
            });
        }
        );
    }
    openSMSLog() {
        this.done.emit(false);
        this.router.navigate(['/reports/smslogreport']);

    }
    getSMS(sms: any) {
        this.receivedsmsService.getSmsReceivedLog(this.globalInfo().CompanyId, this.globalInfo().MaxRoleGroup, this.globalInfo().VendorId, this.globalInfo().LoginId, this.globalInfo().TimeZoneId).subscribe(resp => {

            this.smslogReceived = resp;

            this.smslogReceived.map(m => {

                m.RecvdDate = this.datePipe.transform(m.RecvdDate, 'short');
                return m
            });
        }
        );
    }
    close(success?: boolean) {

        this.done.emit(success);
    }
    openNotification(smsmsg: SmsLogReceived) {

        this.open.emit({ success: true, smslog: smsmsg });

    }




}